import { clearMutationQueue } from './mutationQueue'

const API_CACHE_NAME = 'api-cache'

export const clearApiCache = async (): Promise<void> => {
  if ('caches' in window) {
    await caches.delete(API_CACHE_NAME)
  }
}

export const clearOfflineState = async (): Promise<void> => {
  await Promise.all([clearApiCache(), clearMutationQueue()])
}
